import { redactedCopy } from '@/utils/urlRedaction';

// Faro (Grafana Cloud RUM) records the page URL in `meta.page.url` and in
// event/trace attributes. Faro's first events are sent at init, BEFORE a
// token page's mount effect strips the token (claim/opt-out verify,
// email-preferences, unsubscribe, org-invitation, newsletter confirm), so the
// emailed credential would reach Grafana Cloud for a consenting visitor. The
// redaction itself (query and fragment, plain and percent-encoded, one
// parameter list, no depth limit) is shared with PostHog in ./urlRedaction.

interface FaroItemLike {
  payload: unknown;
  meta: unknown;
}

/**
 * Faro `beforeSend` hook: returns a redacted COPY of the item (sensitive URL
 * params removed from `meta.page.url` and every string in meta and payload:
 * event attributes, navigation `url`s, OTLP span `http.url`, exception values
 * and stack frames). The item Faro passed in is never written to. Returns
 * `null` (Faro drops the item) when the item cannot be copied safely, so an
 * unredacted item is never sent.
 */
export function redactFaroItem<T extends FaroItemLike>(item: T): T | null {
  try {
    return redactedCopy(item);
  } catch {
    // RedactionRefusedError, or anything thrown while reading the payload
    // (a throwing getter, a revoked proxy): fail closed.
    return null;
  }
}
